import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Dialog, { DialogTitle } from 'material-ui/Dialog';
import { 
    DialogActions, 
    DialogContent, 
    Paper } from 'material-ui';
import Button from 'material-ui/Button';
import {CircularProgress} from 'material-ui/Progress';
import green from 'material-ui/colors/green';
import { translate } from 'react-i18next';
import i18n from '../../../services/i18n.js';
import { deleteSpecialDestination } from '../SpecialDestinationServices';

const styles = theme => ({
    root: {
        display: 'flex',

    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '16px',
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main
    }
});

/**
 * Componente modal que permite eliminar un destino especial.
 * Recibe el nombre del destino a eliminar en las props
 * 
 */
class SpecialDestinationDeleteDialog extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            specialDestination:{},
            success: false,
            loading: false        
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        this.setState({
            success:false, 
            loading: false,
            specialDestination: nextProps.specialDestination
        });
    }

    handleClose = async () => {
        if (!this.state.loading) {
            this.setState({ success: false, loading: true});
        }

        const result = await this.deleteSpecialDestination();
        if(result.errorCode && result.errorCode !== 200){
            this.setState({
                success: false,
                loading: false
            });
            const message = result.message.substring(result.message.indexOf(':')+1).trim();
            alert(i18n.t('SPECIAL_DESTINATION.DELETE_SPECIAL_DESTINATION_ERROR') + '\n' + message);
            this.props.onClose(false);
        }
        else{
            this.setState({ success: true, loading: false});
            this.props.onClose(true);
        }


    };

    deleteSpecialDestination = async () => {
        try{
            return await deleteSpecialDestination(this.state.specialDestination);
        } catch (error) {
            return error;
        }
    };

    handleCancel = () => {
        this.props.onClose(null);
    };

    render() {

        const { classes, specialDestination, t, ...other } = this.props;

        if(!this.state)
            return '';

        const {loading, failed, message} = this.state;

        return (
            <Dialog                
                onClose={this.handleClose}
                onEnter={this.handleEnter}
                aria-labelledby="simple-dialog-title"
                fullWidth={true}
                maxWidth='sm'
                {...other}
            >
                <DialogTitle 
                    id="simple-dialog-title" 
                    disableTypography={true} 
                    className={classes.dialogTitle}>
                    {t('SPECIAL_DESTINATION.DELETE_SPECIAL_DESTINATION')}
                </DialogTitle>
                <DialogContent
                    className = "cmsDialogContent"
                
                >
                    <Paper style={{ padding: '12px' }} elevation={0}>

                        <Typography style={{
                            fontSize: '1rem',                            
                        }}>
                            <span className={classes.roomPos}>
                                {t('SPECIAL_DESTINATION.DELETE_LABEL')}
                            </span>
                        </Typography>
                        <span></span>
                        <Typography style={{
                            fontSize: '1.5rem',
                            fontWeight: 'bold',                            
                        }}>
                            <span className={classes.roomPos}>
                                {specialDestination.name}
                            </span>
                        </Typography>
                        {failed ? (
                            <label>{t(message)}</label>
                        ) : (
                            ''
                        )}
                    </Paper>
                </DialogContent>
                <DialogActions className={classes.root + " cmsDialogActions"} style={{ padding: '12px' }}>
                    <div className={classes.wrapper}>
                        <Button
                            disabled={loading}
                            onClick={this.handleCancel}
                        >
                            { t('COMMON.CANCEL') }
                        </Button>
                    </div>
                    <div className={classes.wrapper}>
                        <Button
                            variant="raised"
                            color="secondary"
                            disabled={loading}
                            onClick={this.handleClose}
                        >
                            {t('SPECIAL_DESTINATION.DELETE_SPECIAL_DESTINATION')}
                        </Button>
                        {
                            loading && 
                            <CircularProgress 
                                size={24} 
                                className={classes.buttonProgress} 
                            />
                        }
                    </div>
                </DialogActions>
            </Dialog>
        );
    }
}

SpecialDestinationDeleteDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
};

export default translate('translations')(withStyles(styles)(SpecialDestinationDeleteDialog));


// WEBPACK FOOTER //
// ./src/components/SpecialDestinations/Dialogs/SpecialDestinationDeleteDialog.js